import React, { useState, useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import './App.css';
import './Srch.css';

import Chan03 from './Chan03.png';


function Srch(props) {

  const [value, setValue] = useState(``);
  const [flg, setFlg] = useState(``);
  const [msg, setMsg] = useState(``);

  const [isLoaded, setIsLoaded] = useState(false);

  const [ac_name, setAc_name] = useState(``);
  const [ac_balance, setAc_balance] = useState(`0`);
  const [ac_pubkey, setAc_pubkey] = useState(``);
  const [ac_iGas, setAc_iGas] = useState([]);
  const [ac_iRam, setAc_iRam] = useState([]);
  const [ac_vote, setAc_vote] = useState([]);

  const [t, i18n] = useTranslation();

  const handleChange = (event) => {
    setValue(event.target.value);
  }

  const handleSubmit = (event) => {
    if (value == "") {
      setFlg(`NG`);

      switch (props.lng) {
        case 'ja':
          setMsg(`検索フォームにアカウント名が入力されていません。`);
          break;
        case 'en':
          setMsg(`The account name has not been entered in the search form.`);
          break;
        case 'cn':
          setMsg(`你没有在搜索表格中输入你的账户名称。`);
          break;
      }

      event.preventDefault();

    } else {
      fetch("https://api.iost.io/getAccount/" + value + "/true")
        .then(res => res.json())

        .then(json => {

          console.log(json);
          if (json.code == 2) {
            setFlg(`NG`);

            switch (props.lng) {
              case 'ja':
                setMsg(`アカウントが存在しないか、正しい値が入力されていません。`);
                break;
              case 'en':
                setMsg(`Either the account does not exist or the correct value has not been entered.`);
                break;
              case 'cn':
                setMsg(`要么该账户不存在，要么没有输入正确的数值。`);
                break;
            }

          } else {

            var pky = json.permissions.active.items[0];
            var vif = json.vote_infos;
            var god = [];


            setFlg(`OK`);
            setIsLoaded(true);
            setAc_name(json.name);
            setAc_balance(json.balance);
            setAc_pubkey(pky.id);
            setAc_iGas(json.gas_info);
            setAc_iRam(json.ram_info);
            setAc_vote(vif);


          };
        });
      event.preventDefault();
    }
  }

  let notice;
  var oko = flg;
  if (oko == "NG") {
    notice =
      <div className="SrchRes">
        <div className="box">
          <h3>{t('お知らせ')}</h3>
          <p>
            {msg}
          </p>
        </div>
      </div>;
  } else if (oko == "OK") {
    notice =
      <div className="SrchRes">

        <div className="box">
          <h3>{t(`アカウント名`)}</h3>
          <p>
            {ac_name}
          </p>
        </div>

        <div className="box">
          <h3>{t(`公開鍵`)}</h3>
          <p>
            {ac_pubkey}
          </p>
        </div>

        <div className="box">
          <h3>{t(`残高`)}</h3>
          <p>
            IOST：{ac_balance} IOST
          </p>
        </div>

        <div className="box">
          <h3>{t(`iGas情報`)}</h3>
          <p>
            {t(`残高`)}：{ac_iGas.current_total}<br></br>
            {t(`最大`)}：{ac_iGas.limit}<br></br>
          </p>
        </div>

        <div className="box">
          <h3>{t(`iRam情報`)}</h3>
          <p>
            {t(`残高`)}：{ac_iRam.available}<br></br>
            {t(`最大`)}：{ac_iRam.total}<br></br>
          </p>
        </div>

        <div className="box">
          <h3>{t(`投票先情報`)}</h3>
          <p>
            <table className='tbl'>
              <tr>
                <th>{t(`投票先`)}</th>
                <th>{t(`投票数`)}</th>
                <th>{t(`報酬残高`)}</th>
              </tr>
              {ac_vote.map((reptile) => (
                <tr>
                  <td>{reptile.option}</td>
                  <td>{reptile.votes}</td>
                  <td>{reptile.cleared_votes}</td>
                </tr>
              ))}
            </table>
          </p>
        </div>
      </div>;
  }

  return (
    <div className="Srch">
      <div className="PgName">👀{t('アカウントをしらべる')}</div>

      <button className="Back" onClick={() => props.pg(`menu`)}>{t('もどる')}</button>

      <form onSubmit={handleSubmit}>
        <input className="SrchAc" type="text" value={value} onChange={handleChange} />
        <input className="SrchBtn" type="submit" value={t('検索')} />
      </form>

      <div className="SrchImg">
        <img src={Chan03} alt="検索してね！" />
      </div>

      {notice}

    </div>

  );
}

export default Srch;